export enum FilterLimitPresets {
  LIMIT_5 = 5,
  LIMIT_100 = 100,
  LIMIT_1K = 1_000,
  LIMIT_2K = 2_000,
  LIMIT_5K = 5_000,
  LIMIT_10K = 10_000,
  LIMIT_15K = 15_000,
  LIMIT_20K = 20_000,
  LIMIT_50K = 50_000,
}

/**
 * Filter limit for the Territory filter.
 *
 * - **🔗 Mapped to:** [FilterType.TERRITORY]
 * - **📊 Limit preset:** 10,000 results
 */
export const TERRITORY_FILTER_LIMIT = FilterLimitPresets.LIMIT_10K;

/**
 * Filter limit for the State Province filter.
 *
 * - **🔗 Mapped to:** [FilterType.STATE_PROVINCE]
 * - **📊 Limit preset:** 5,000 results
 */
export const STATE_PROVINCE_FILTER_LIMIT = FilterLimitPresets.LIMIT_5K;

/**
 * Filter limit for the Therapeutic Area (TA) filter / HCP Primary specialty.
 *
 * - **🔗 Mapped to:** [FilterType.TA]
 * - **📊 Limit preset:** 1,000 results
 */
export const TA_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the Trial Sponsor filter.
 *
 * - **🔗 Mapped to:** [FilterType.TRIAL_SPONSOR]
 * - **📊 Limit preset:** 1,000 results
 */
export const TRIAL_SPONSOR_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the HCP Profession filter / HCP Type.
 *
 * - **🔗 Mapped to:** [FilterType.HCP_PROFESSION]
 * - **📊 Limit preset:** 1,000 results
 */
export const HCP_PROFESSION_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the HCP Type of Practice filter.
 *
 * - **🔗 Mapped to:** [FilterType.HCP_TYPE_OF_PRACTICE]
 * - **📊 Limit preset:** 1,000 results
 */
export const HCP_TYPE_OF_PRACTICE_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the TA Indications filter.
 *
 * - **🔗 Mapped to:** [FilterType.TA_INDICATIONS]
 * - **📊 Limit preset:** 1,000 results
 */
export const TA_INDICATIONS_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the Products filter.
 *
 * - **🔗 Mapped to:** [FilterType.PRODUCTS]
 * - **📊 Limit preset:** 1,000 results
 */
export const PRODUCTS_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the Topic filter.
 *
 * - **🔗 Mapped to:** [FilterType.TOPIC]
 * - **📊 Limit preset:** 10,000 results
 */
export const TOPIC_FILTER_LIMIT = FilterLimitPresets.LIMIT_10K;

/**
 * Filter limit for the Email Campaign filter.
 *
 * - **🔗 Mapped to:** [FilterType.EMAIL_CAMPAIGN]
 * - **📊 Limit preset:** 15,000 results
 */
export const EMAIL_CAMPAIGN_FILTER_LIMIT = FilterLimitPresets.LIMIT_15K;

/**
 * Filter limit for the Event Name filter.
 *
 * - **🔗 Mapped to:** [FilterType.EVENT_NAME]
 * - **📊 Limit preset:** 15,000 results
 */
export const EVENT_NAME_FILTER_LIMIT = FilterLimitPresets.LIMIT_15K;

/**
 * Filter limit for the Event Type filter.
 *
 * - **🔗 Mapped to:** [FilterType.EVENT_TYPE]
 * - **📊 Limit preset:** 100 results
 */
export const EVENT_TYPE_FILTER_LIMIT = FilterLimitPresets.LIMIT_100;

/**
 * Filter limit for the Field Force filter.
 *
 * - **🔗 Mapped to:** [FilterType.FIELD_FORCE]
 * - **📊 Limit preset:** 5,000 results
 */
export const FIELD_FORCE_FILTER_LIMIT = FilterLimitPresets.LIMIT_5K;

/**
 * Filter limit for the Website/Portal filter.
 *
 * - **🔗 Mapped to:** [FilterType.WEBSITE_PORTAL]
 * - **📊 Limit preset:** 1,000 results
 */
export const WEBSITE_PORTAL_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for TIER/Fair Market Value (FMV) rating filter.
 *
 * - **🔗 Mapped to:** [FilterType.FAIR_MARKET_VALUE_RATING]
 * - **📊 Limit preset:** 100 results
 */
export const FAIR_MARKET_VALUE_RATING_FILTER_LIMIT = FilterLimitPresets.LIMIT_100;
/**
 * Filter limit for Secondary specialty filter.
 *
 * - **🔗 Mapped to:** [FilterType.SECONDARY_SPECIALTY]
 * - **📊 Limit preset:** 100 results
 */
export const SECONDARY_SPECIALTY_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for Event source country filter.
 *
 * - **🔗 Mapped to:** [FilterType.EVENT_SOURCE]
 * - **📊 Limit preset:** 1000 results
 */
export const EVENT_SOURCE_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the HCO Country filter.
 *
 * - **🔗 Mapped to:** [FilterType.HCO_COUNTRY]
 * - **📊 Limit preset:** 1,000 results
 */
export const HCO_COUNTRY_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the HCO Type filter.
 *
 * - **🔗 Mapped to:** [FilterType.HCO_TYPE]
 * - **📊 Limit preset:** 1,000 results
 */
export const HCO_TYPE_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the HCO Specialty filter.
 *
 * - **🔗 Mapped to:** [FilterType.HCO_SPECIALTY]
 * - **📊 Limit preset:** 1,000 results
 */
export const HCO_SPECIALTY_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;

/**
 * Filter limit for the HCO Private/Public status filter.
 *
 * - **🔗 Mapped to:** [FilterType.HCO_PRIVATE_PUBLIC_STATUS]
 * - **📊 Limit preset:** 1,000 results
 */
export const HCO_PRIVATE_PUBLIC_STATUS_FILTER_LIMIT = FilterLimitPresets.LIMIT_1K;
